export const supportEmail = "support+SAT@fcim.org";
export const defaultRecordsPerPage = 10;

export const apiUrl = (process.env.NODE_ENV === 'production') ? "//sat.fcim.org/api/" : "http://localhost:20821/api/";

export const mockAtExpiresInSeconds = 900;
export const mockRtExpiresInSeconds = 5400;

export const courseLandingPage = (process.env.NODE_ENV === 'production') ? "/courses/SAT/index.html" : "/course";
export const adminLandingPage = "/admin/menu";

export const useRefreshToken = "useRefreshToken";